<template>
  <div class="container page" style="background-color: #1f1c1f">
    <van-nav-bar :title="$t('vip.title')" class="nav-bar">
      <template #left>
        <img
          src="/img/newLogin/download.png"
          @click="back()"
          style="width: 20px; height: 15px"
        />
      </template>
    </van-nav-bar>
    <div class="u_bg"></div>
    <div class="content_re">
      <div class="vip_header">
        <div class="vip_title">{{ $t("vip.privilege") }}</div>
        <div class="vip_subtitle">{{ $t("vip.upgrade_standard") }}</div>
      </div>

<div class="vip_card" v-for="(item, index) in vipLevels" :key="index">
  <div class="vip_level">
    <span class="level_icon"></span>
    <span class="level_name">{{ item.level }}</span>
  </div>

  <div class="vip_info">
    <div class="info_row">
      <span class="info_label">{{ $t("vip.deposit_amount") }}</span>
      <span class="info_value">{{ item.deposit }}</span>
    </div>

    <div class="info_row">
      <span class="info_label">{{ $t("vip.bonus_amount") }}</span>
      <span class="info_value bonus">{{ item.bonus }}</span>
    </div>
  </div>

  <div class="vip_privilege">
    <div class="privilege_label">{{ $t("vip.core_privilege") }}</div>
    <div class="privilege_text">{{ item.privilege }}</div>
  </div>

  <!-- ͼƬ -->
  <div class="vip_image">
    <img
      :src="item.image"
      @click="previewImage(item.image)"
    />
  </div>
</div>
    </div>
  </div>
</template>

<script>
	import { ImagePreview } from 'vant'
export default {
  data() {
    return {
      vipLevels: [
        {
          level: "SVIP2",
          deposit: "3,000",
          bonus: "1,000",
          privilege: this.$t("vip.vip2_privilege"),
		image: '/img/vip/2.jpg'
        },
        {
          level: "SVIP3",
          deposit: "8,000",
          bonus: "3,000",
          privilege: this.$t("vip.vip3_privilege"),
		image: '/img/vip/3.jpg'
        },
        {
          level: "SVIP4",
          deposit: "15,000",
          bonus: "6,000",
          privilege: this.$t("vip.vip4_privilege"),
		image: '/img/vip/4.jpg'
        },
        {
          level: "SVIP5",
          deposit: "30,000",
          bonus: "15,000",
          privilege: this.$t("vip.vip5_privilege"),
		image: '/img/vip/5.jpg'
        },
      ],
    };
  },
  methods: {
    back() {
      return window.history.back();
    },
    previewImage(image) {
      ImagePreview({
        images: [image],
        closeable: true
      })
    }
  },
};
</script>

<style lang="less" scoped>
@import "../../assets/css/base.css";
.vip_image {
  width: 100%;
  margin-top: 15px;
  text-align: center;
}

.vip_image img {
  width: 100%;
  max-height: 200px;
  object-fit: cover;
  border-radius: 8px;
  display: block;
  cursor: pointer;
}
.u_bg {
  background: linear-gradient(to right, #efcba7, #dcab76);
  height: 300px;
  position: absolute;
  width: 100%;
}

.content_re {
  position: relative;
  width: 100%;
  padding-bottom: 100px;
}

.vip_header {
  padding: 40px 40px 30px 40px;
  text-align: center;
  .vip_title {
    font-size: 36px;
    color: #333;
    font-weight: bold;
    margin-bottom: 10px;
  }
  .vip_subtitle {
    font-size: 24px;
    color: #333;
    opacity: 0.8;
  }
}

.vip_card {
  background: linear-gradient(120deg, #212121, #313131);
  border-radius: 10px;
  margin: 0 40px 20px 40px;
  padding: 30px;
  border: 1px solid #766350;

  .vip_level {
    display: flex;
    align-items: center;
    margin-bottom: 20px;
    .level_icon {
      font-size: 40px;
      margin-right: 15px;
    }
    .level_name {
      font-size: 32px;
      color: #e6b98a;
      font-weight: bold;
    }
  }

  .vip_info {
    background: rgba(0, 0, 0, 0.3);
    border-radius: 8px;
    padding: 20px;
    margin-bottom: 20px;

    .info_row {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 10px 0;

      .info_label {
        font-size: 24px;
        color: #fff;
      }

      .info_value {
        font-size: 28px;
        color: #e6b98a;
        font-weight: bold;

        &.bonus {
          color: #ffd700;
        }
      }
    }
  }

  .vip_privilege {
    .privilege_label {
      font-size: 22px;
      color: #e6b98a;
      margin-bottom: 10px;
      font-weight: bold;
    }

    .privilege_text {
      font-size: 24px;
      color: #fff;
      line-height: 1.6;
    }
  }
}

::v-deep .van-nav-bar__content {
  height: 100px;
}

::v-deep .van-hairline--bottom::after {
  border-bottom-width: 0px;
}

@media screen and (min-width: 1024px) {
  .container {
    width: 430px;
    margin: 0 auto;
    height: 100vh;
    box-shadow: 0 10px 40px rgba(0, 0, 0, 0.8),
      0 0 0 1px rgba(255, 255, 255, 0.05);
  }

  .nav-bar {
    height: 50px;
  }

  ::v-deep .van-nav-bar__content {
    height: 50px;
  }

  .content_re {
    padding-bottom: 40px;
  }

  .vip_header {
    padding: 20px;

    .vip_title {
      font-size: 28px;
      color: #fff;
    }

    .vip_subtitle {
      font-size: 18px;
      color: rgba(255, 255, 255, 0.8);
    }
  }

  .vip_card {
    margin: 0 30px 18px;
    padding: 20px;
    border-radius: 10px;
    transition: all 0.2s;
    border: 1px solid #766350;

    &:hover {
      border-color: #e7b486;
      box-shadow: 0 0 15px rgba(231, 180, 134, 0.2);
      transform: translateY(-2px);
    }

    .vip_level {
      margin-bottom: 15px;

      .level_icon {
        font-size: 32px;
        margin-right: 12px;
      }

      .level_name {
        font-size: 26px;
      }
    }

    .vip_info {
      padding: 15px;
      margin-bottom: 15px;

      .info_row {
        padding: 8px 0;

        .info_label {
          font-size: 18px;
          color: #ccc;
        }

        .info_value {
          font-size: 22px;
        }
      }
    }

    .vip_privilege {
      .privilege_label {
        font-size: 18px;
        margin-bottom: 8px;
      }

      .privilege_text {
        font-size: 18px;
        color: #ccc;
        line-height: 1.6;
      }
    }
  }
}
</style>
